const MENU_ITEM_TYPE = {
  ITEM: "item",
  GROUP: "group",
  DIVIDER: "divider",
  SUB_MENU: "sub-menu"
  // not implemented
};
export {
  MENU_ITEM_TYPE as default
};
//# sourceMappingURL=menu.es.js.map
